import styled from "styled-components"

export const Flash = styled.div`
  background: ${props => props.theme.danger};
  color: ${props => props.theme.dangerText};
  padding: 1rem;
  display: flex;
  align-items: center;
  min-height: 4.4rem;
`



// WEBPACK FOOTER //
// ./src/UI/Flash/index.js